import React, { useMemo, useState } from "react";
import hljs from "highlight.js";
import "highlight.js/styles/atom-one-dark.css";
import styles from './ModuleCodeContainer.module.scss';
import RichTextParser from "../RichTextParser";

const ModuleCodeContainer = ({ textFormat, code }) => {
    const [copied, setCopied] = useState(false);

    const extractText = (node) => {
        if (!node) return "";

        if (typeof node === "string") return node;

        if (node.nodeType === "text") {
            return node.value || "";
        }

        if (node.content) {
            return node.content.map(extractText).join("");
        }

        return "";
    };

    const language =
        textFormat?.toLowerCase() === "plain text"
            ? "plaintext"
            : textFormat?.toLowerCase() || "plaintext";


    const getHighlightedCode = (rawCode) => {
        if (!rawCode) return "";

        try {
            return hljs.highlight(rawCode, {
                language,
                ignoreIllegals: true
            }).value;
        } catch (error) {
            return hljs.highlight(rawCode, {
                language: "plaintext"
            }).value;
        }
    };

 
    const handleCopy = async (rawCode) => {
        try {
            await navigator.clipboard.writeText(rawCode);
            setCopied(true);

            setTimeout(() => {
                setCopied(false);
            }, 2000);
        } catch (error) {
            console.error("Failed to copy code:", error);
        }
    };

    return (
        <div>
            {code?.content?.length > 0 &&
                code.content.map((ele, index) => {
                    const isCode =
                        ele?.content?.[0]?.marks?.[0]?.type === "code";

                    if (isCode) {
                        const rawCode = extractText(ele);

                        const highlightedCode =
                            getHighlightedCode(rawCode);

                        return (
                            <div
                                className={styles.modulecodecontainer}
                                key={index}
                            >
                                <pre>
                                    <code
                                        className={`hljs ${language !== "plaintext" ? `language-${language}` : ""}`}
                                        dangerouslySetInnerHTML={{
                                            __html: highlightedCode
                                        }}
                                    />
                                </pre>

                                <button
                                    className={styles.copybutton}
                                    onClick={() => handleCopy(rawCode)}
                                >
                                    {!copied && <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M2.66699 0V8.33333H11.0003V0H2.66699ZM10.0003 7.33333H3.66699V1H10.0003V7.33333Z" fill="#1E1919"></path>
                                        <path d="M0.666992 2H1.66699V9.33333H9.00033V10.3333H0.666992V2Z" fill="#1E1919"></path>
                                    </svg>}
                                    <span className={copied ? styles.copiedButton : styles.copyButton}>{copied ? "Copied" : "Copy"}</span>
                                </button>
                            </div>
                        );
                    }

                    return (
                        <RichTextParser
                            document={ele}
                            key={index}
                        />
                    );
                })}
        </div>
    );
};

export default ModuleCodeContainer;